import { render, staticRenderFns } from "./ZoomControl.vue?vue&type=template&id=1b4f4f6c&"
import script from "./ZoomControl.vue?vue&type=script&lang=js&"
export * from "./ZoomControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports